import type { TenantStateSet } from '@chatbot/shared-types';
import { stateLabel } from '../../lib/state-labels.ts';
import type { TicketRow as Ticket } from '../../lib/types.ts';

/** "hace 3 días", sin traer una librería de fechas para una línea. */
function hace(desde: string): string {
  const ms = Date.now() - new Date(desde).getTime();
  const horas = Math.floor(ms / 3_600_000);
  if (horas < 1) return 'recién';
  if (horas < 24) return `hace ${horas} h`;
  const dias = Math.floor(horas / 24);
  return dias === 1 ? 'hace 1 día' : `hace ${dias} días`;
}

export interface TicketRowProps {
  ticket: Ticket;
  states: TenantStateSet;
  seleccionado: boolean;
  onSelect: (ticket: Ticket) => void;
}

/**
 * Una fila de la cola.
 *
 * La etiqueta del estado sale de `stateLabel`, **nunca de una constante local**:
 * un tenant que llama "En taller" a su estado abierto lo ve así sin que nadie
 * toque este archivo (ADR-023).
 */
export function TicketRowItem({ ticket, states, seleccionado, onSelect }: TicketRowProps) {
  const abierto = ticket.stateTerminal === false;
  return (
    <button
      type="button"
      onClick={() => onSelect(ticket)}
      aria-current={seleccionado ? 'true' : undefined}
      className={`flex w-full flex-col gap-1 border-edge-subtle border-b px-4 py-3 text-left transition-colors hover:bg-surface-sunken ${
        seleccionado ? 'bg-surface-sunken' : ''
      }`}
    >
      <div className="flex items-baseline justify-between gap-3">
        <span data-testid="ticket-summary" className="text-body text-content-primary">
          {ticket.summary ?? 'Sin asunto'}
        </span>
        <span className="shrink-0 text-caption text-content-tertiary">{hace(ticket.openedAt)}</span>
      </div>
      <div className="flex items-center gap-2">
        <span
          className={`rounded-full px-2 py-0.5 text-caption ${
            abierto
              ? 'bg-warning-50 text-warning-700 dark:bg-warning-900/20 dark:text-warning-300'
              : 'bg-surface-sunken text-content-secondary'
          }`}
        >
          {stateLabel(states, ticket.status)}
        </span>
        {ticket.assignedTo ? (
          <span className="text-caption text-content-tertiary">{ticket.assignedTo}</span>
        ) : (
          <span className="text-caption text-content-tertiary">Sin asignar</span>
        )}
      </div>
    </button>
  );
}
